import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { PopupComponent } from '@app/components/popup/popup.component';
import { BaseService } from '@app/system/services/base.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { LocaleService } from '@app/system/services/locale.service';
import { ApiService } from '../utilities/services/api.service';

@Component({
	selector: 'app-take-test',
	templateUrl: './take-test.component.html',
	styleUrls: ['./take-test.component.scss']
})
export class TakeTestComponent implements OnInit, OnDestroy {

	@Input() testID;
	@Output() startTest = new EventEmitter();
	@Output() testDetail = new EventEmitter();

	testData;
	record;
	popupRef;
	action: 'testStart' | 'testInprogress' | 'testEnd' | 'timeUp' | 'questions' | 'testCompleted' = 'testStart';
	submitButtonDisable = false;
	questions = [];
	currentIndex = 0;
	totalAnswerCount = 0;
	duration;
	interval;
	currentQuestion;
	loader = false;
	lastAction: string;
	sectionLoader = false;
	courseID;
	heartBeatInterval;
	heartBeatSubscribe;
	userTestID;
	heartBeatCode;
	navigationData = [];
	currentNavigationIndex = 0;
	lastNavigationData: {
		index: number;
		type: string;
		ID: number;
	} = null;
	reachedEnd = false;
	endTestData;
	forceToEnd = false;

	constructor(
		public locale: LocaleService,
		private apiService: ApiService,
		public gfService: GlobalFunctionService,
		private popup: MatDialog,
		private baseService: BaseService
	) { }

	ngOnInit(): void {
		addEventListener('offline', () => {
			if (this.popupRef) {
				this.popupRef.close('close');
			}
		});
		if (this.action === 'testStart') {
			if (this.popupRef) {
				this.popupRef.componentInstance.popupLoader = true;
			}
			let testID;
			if (this.testID) {
				this.sectionLoader = true;
				testID = this.testID;
			} else {
				testID = this.record.testID;
			}
			const apiData = {};
			const headers: any = {};
			this.apiService.getTestDetail(apiData, testID, headers).subscribe(
				(response) => {
					if (response) {
						this.dataBuild(response);
						this.testDetail.emit(this.testData);
						// this.testData.duration = 120;
					}
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
				.add(() => {
					if (this.testID) {
						this.sectionLoader = false;
					}
					if (this.popupRef) {
						this.popupRef.componentInstance.popupLoader = false;
					}
					this.submitButtonDisable = false;
				});
		} else if (this.action === 'testInprogress') {
			this.popupRef.componentInstance.popupLoader = true;
			this.dataBuild(this.testData);
			this.getQuestion(true);
		}
	}

	dataBuild(record) {
		record.durationInSeconds = record.duration * 60;
		// record.userTestStatus = 2;
		const testStatus = this.baseService.referenceType('testStatus', record.userTestStatus);
		if (testStatus) {
			// if (['interrupted', 'live'].includes(this.testData.userTestStatus.key)) {
			// 	record.durationInSeconds = record.remainingDuration * 60;
			// }
			record.userTestStatus = testStatus;
		}
		if (record.totalQuestion) {
			for (let i = 0; i < record.totalQuestion; i++) {
				const pushJson: any = {
					type: (i === 0) ? 'current' : 'not-answered'
				};
				this.navigationData.push(pushJson);
			}
		}
		this.testData = record;
	}

	takeTest() {
		if (navigator.onLine && this.testData && this.testData.totalQuestion) {
			if (this.testID) {
				this.startTest.emit(this.testData);
			} else {
				this.action = 'testInprogress';
				this.popupRef.componentInstance.popupLoader = true;
				this.getQuestion(true);
			}
		}
	}

	getQuestion(first = false, updateNavigationAction = null) {
		if (navigator.onLine) {
			let apiData: any = {};
			const headers: any = {};
			let currentType: 'start' | 'resume' | 'next' = 'start';
			let method;
			let testID;
			if (this.testID) {
				testID = this.testID;
			} else {
				testID = this.testData.testID;
			}
			if (first) {
				if (this.testData && this.testData.userTestStatus && ['interrupted', 'live'].includes(this.testData.userTestStatus.key)) {
					currentType = 'resume';
					apiData = {};
					method = this.apiService.resumeTest(apiData, this.testData.userTestID, headers);
				} else {
					currentType = 'start';
					apiData = {
						courseID: this.courseID
					};
					apiData.testID = testID;
					method = this.apiService.startTest(apiData, headers);
				}
			} else {
				currentType = 'next';
				apiData = {};
				method = this.apiService.getNextQuestion(apiData, this.userTestID, headers);
			}
			method.subscribe(
				(response) => {
					if (response) {
						if (updateNavigationAction) {
							if (updateNavigationAction === 'skip') {
								const question = this.questions.find(items => items.ID === this.currentQuestion.ID);
								if (question) {
									question.skipped = this.currentQuestion.skipped;
								}
							}
							this.updateNavigation(updateNavigationAction);
						}
						if (first) {
							if (currentType === 'resume') {
								if (response.remainingDuration && Number(response.remainingDuration) !== NaN) {
									this.testData.durationInSeconds = Number(response.remainingDuration) * 60;
								}
							}
							this.duration = this.formatTime(this.testData.durationInSeconds);
							this.manageTime();
							this.manageHeartBeat();
							if (currentType === 'resume') {
								this.heartBeatCode = response.heartBeatCode;
								this.userTestID = this.testData.userTestID;
								if (response.questionsCurrentStatus && response.questionsCurrentStatus.length) {
									const navigation = [];
									response.questionsCurrentStatus.map(resp => {
										const status = this.baseService.referenceType('testQuestionStatus', resp.status);
										if (status) {
											if (status.key === 'answered') {
												navigation.push(
													{
														type: 'answered'
													}
												);
											} else if (status.key === 'attempted') {
												navigation.push(
													{
														type: 'skipped'
													}
												);
											}
										}
									});
									if (navigation.length) {
										this.currentNavigationIndex = navigation.length;
										let data = navigation.concat(this.navigationData);
										if (this.navigationData.length && data.length > this.testData.totalQuestion) {
											data = data.slice(0, this.testData.totalQuestion);
										}
										this.navigationData = data;
									}
								}
								if ([null, undefined].includes(response.nextQuestion)) {
									this.forceToEnd = true;
									this.action = 'testEnd';
									return false;
								}
								this.currentQuestion = response.nextQuestion;
							} else {
								this.currentQuestion = response.firstQuestion;
								this.heartBeatCode = response.heartBeatCode;
								this.userTestID = response.recordID;
							}
						} else {
							this.currentQuestion = response;
						}
						this.currentQuestion.questionType = this.baseService.referenceType('questionType', this.currentQuestion.questionType);
						this.questions.push(this.currentQuestion);
						this.navigationData[this.currentNavigationIndex].ID = this.currentQuestion.ID;
						// this.questions = response.records;
					} else {
						if (updateNavigationAction) {
							this.updateNavigation(updateNavigationAction);
						}
						this.calculateTotal();
						this.action = 'testEnd';
						this.currentIndex = this.questions.length - 1;
						this.reachedEnd = true;
					}
				},
				(error) => {
					if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === 'INSUFFICIENT_QUESTIONS') {
						error.error = this.locale.translate('there_are_no_questions_to_show');
					} else if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === 'ASSESSMENT_INTERRUPTED') {
						error.error = this.locale.translate('the_test_was_interrupted');
					} else if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === 'ASSESSMENT_COMPLETED') {
						error.error = this.locale.translate('already_you_will_be_completed_the_test');
					}
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
					if (['start', 'resume'].includes(currentType) && this.popupRef) {
						this.popupRef.close('close');
					}
				}
			)
				.add(() => {
					this.popupRef.componentInstance.popupLoader = false;
					this.loader = false;
					this.submitButtonDisable = false;
				});
		}
	}

	answerChange(event) {
		this.currentQuestion.answer = event;
	}

	manageTime() {
		if (navigator.onLine) {
			this.interval = setInterval(() => {
				if (this.testData.durationInSeconds) {
					this.testData.durationInSeconds -= 1;
					this.duration = this.formatTime(this.testData.durationInSeconds);
				} else if (this.interval) {
					this.endTest('timeUp');
					clearInterval(this.interval);
					if (this.heartBeatInterval) {
						clearInterval(this.heartBeatInterval);
					}
				}
			}, 1000);
		}
	}

	manageHeartBeat() {
		if (navigator.onLine) {
			this.heartBeatInterval = setInterval(() => {
				if (this.testData.durationInSeconds) {
					if ((this.heartBeatSubscribe === undefined || this.heartBeatSubscribe.closed) && navigator.onLine) {
						this.updateHeartBeat();
					}
				} else if (this.heartBeatInterval) {
					clearInterval(this.heartBeatInterval);
				}
			}, 10000);
		}
	}

	updateHeartBeat() {
		const apiData = {
			heartBeatCode: this.heartBeatCode
		};
		const headers: any = {};
		this.heartBeatSubscribe = this.apiService.testHeartBeat(apiData, headers).subscribe(
			(response) => {

			},
			(error) => {
				let showError = false;
				if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === 'ASSESSMENT_INTERRUPTED') {
					showError = true;
					if (this.popupRef) {
						this.popupRef.close('close');
					}
					error.error = this.locale.translate('the_test_was_interrupted');
				} else if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === 'ASSESSMENT_COMPLETED') {
					showError = true;
					this.updateNavigation('next');
					if (this.heartBeatInterval) {
						clearInterval(this.heartBeatInterval);
					}
					this.endTest('completed');
					error.error = this.locale.translate('already_you_will_be_completed_the_test');
				}
				if (showError) {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			}
		)
			.add(() => { });
	}

	previous() {
		if (navigator.onLine) {
			if (this.questions[this.currentIndex - 1]) {
				this.updateNavigation('previous');
				this.currentIndex -= 1;
				this.currentQuestion = { ...this.questions[this.currentIndex] };
			}
		}
	}

	updateNavigation(action: 'next' | 'skip' | 'previous') {
		if (this.navigationData[this.currentNavigationIndex]) {
			if (action === 'previous') {
				if (this.currentQuestion.answer) {
					this.navigationData[this.currentNavigationIndex].type = 'answered';
				} else if (this.currentQuestion.skipped) {
					this.navigationData[this.currentNavigationIndex].type = 'skipped';
				} else {
					this.navigationData[this.currentNavigationIndex].type = 'not-answered';
				}
				if (this.currentQuestion.markForReview) {
					this.navigationData[this.currentNavigationIndex].type = 'mark-review';
				}
				if (this.navigationData[this.currentNavigationIndex - 1]) {
					this.navigationData[this.currentNavigationIndex - 1].type = 'current';
					this.currentNavigationIndex -= 1;
				}
			} else {
				if (action === 'next') {
					if (this.currentQuestion.answer) {
						this.navigationData[this.currentNavigationIndex].type = 'answered';
					}
					if (this.currentQuestion.markForReview) {
						this.navigationData[this.currentNavigationIndex].type = 'mark-review';
					}
				} else if (action === 'skip') {
					this.navigationData[this.currentNavigationIndex].type = 'skipped';
				}
				this.lastNavigationData = {
					index: this.currentNavigationIndex,
					type: this.navigationData[this.currentNavigationIndex].type,
					ID: this.navigationData[this.currentNavigationIndex].ID
				};
				if (this.navigationData[this.currentNavigationIndex + 1]) {
					this.navigationData[this.currentNavigationIndex + 1].type = 'current';
					this.currentNavigationIndex += 1;
				}
			}
		}
	}

	next() {
		if (navigator.onLine) {
			this.resetNavigation();
			if (this.questions[this.currentIndex] && this.questions[this.currentIndex].ID === this.currentQuestion.ID) {
				delete this.currentQuestion.skipped;
				if (this.currentQuestion.markForReview !== this.questions[this.currentIndex].markForReview) {
					this.questions[this.currentIndex].markForReview = this.currentQuestion.markForReview;
				}
				if (this.currentQuestion.answer !== this.questions[this.currentIndex].answer) {
					this.updateQuestion();
				} else if (this.questions[this.currentIndex + 1]) {
					this.updateNavigation('next');
					this.currentQuestion = { ...this.questions[this.currentIndex + 1] };
					this.currentIndex += 1;
				} else {
					if (this.reachedEnd) {
						this.updateNavigation('next');
						this.action = 'testEnd';
						this.calculateTotal();
					} else {
						this.updateQuestion();
					}
				}
			}
		}
	}

	skip() {
		if (navigator.onLine) {
			this.resetNavigation();
			this.currentQuestion.skipped = true;
			if (this.questions[this.currentIndex] && this.questions[this.currentIndex].ID === this.currentQuestion.ID) {
				delete this.currentQuestion.answer;
				delete this.currentQuestion.markForReview;
				if (this.questions[this.currentIndex + 1]) {
					this.updateNavigation('skip');
					this.currentQuestion = { ...this.questions[this.currentIndex + 1] };
					this.currentIndex += 1;
				} else {
					if (this.reachedEnd) {
						this.action = 'testEnd';
						this.calculateTotal();
						this.updateNavigation('skip');
					} else {
						this.popupRef.componentInstance.popupLoader = true;
						this.submitButtonDisable = true;
						this.getQuestion(false, 'skip');
						this.currentIndex += 1;
					}
				}
			}
		}
	}

	navigate(data, index) {
		if (navigator.onLine && !this.testData.testEnded) {
			if (data.ID) {
				if (this.lastNavigationData) {
					if (this.navigationData[this.lastNavigationData.index]) {
						console.log(this.navigationData[this.lastNavigationData.index], this.questions, this.lastNavigationData);
						this.navigationData[this.lastNavigationData.index].type = this.lastNavigationData.type;
					}
				}
				this.lastNavigationData = {
					index: index,
					type: data.type,
					ID: data.ID
				};
				// this.navigationData.map((resp, navigationIndex) => {
				// 	if(resp.type === 'current') {
				// 		if(resp.ID)
				// 	}
				// });
				this.resetNavigation();
				this.questions.find((resp, questionIndex) => {
					if (resp.ID === data.ID) {
						if (this.action === 'testEnd') {
							this.action = 'testInprogress';
						}
						this.currentQuestion = { ...resp };
						this.currentIndex = questionIndex;
						this.currentNavigationIndex = index;
						data.type = 'current';
					}
				});
			}
		}
	}

	resetNavigation() {
		const selected = this.navigationData.find(items => items.type === 'current');
		if (selected) {
			if (selected.ID !== this.currentQuestion.ID) {
				const question = this.questions.find(items => items.ID === selected.ID);
				if (question) {
					if (question.answer) {
						selected.type = 'answered';
					} else if (question.skipped) {
						selected.type = 'skipped';
					} else {
						selected.type = 'not-answered';
					}
					if (question.markForReview) {
						selected.type = 'mark-review';
					}
				}
			}
			// selected.type = 'not-answered';
		}
	}

	questionNavigation(data) {
		if (!this.testData.testEnded) {
			this.currentQuestion = { ...data };
			this.resetNavigation();
			this.questions.map((resp, index) => {
				if (resp.ID === data.ID) {
					this.currentIndex = index;
					const currentNavigationIndex = this.navigationData.findIndex(items => items.ID === resp.ID);
					this.currentNavigationIndex = currentNavigationIndex;
					if (currentNavigationIndex >= 0) {
						this.lastNavigationData = {
							index: currentNavigationIndex,
							type: this.navigationData[currentNavigationIndex].type,
							ID: data.ID
						};
						this.navigationData[currentNavigationIndex].type = 'current';
					}
				}
			});
			this.action = 'testInprogress';
		}
	}

	updateQuestion(next = true, updateNavigationAction = false) {
		this.popupRef.componentInstance.popupLoader = true;
		this.submitButtonDisable = true;
		const apiData: any = {};
		const headers: any = {};
		if (this.currentQuestion.answer) {
			apiData.answer = this.currentQuestion.answer;
			const testQuestionStatus = this.baseService.testQuestionStatus;
			for (const status of testQuestionStatus) {
				if (status.key === 'answered') {
					apiData.status = status.value;
				}
			}
		}
		// if (![null, undefined, ''].includes(this.currentQuestion.markForReview)) {
		// 	apiData.markForReview = (this.currentQuestion.markForReview) ? 1 : 0;
		// }
		// if (this.currentQuestion.skipped) {
		// 	apiData.status = 3;
		// }
		this.apiService.updateTestQuestion(apiData, this.userTestID, this.currentQuestion.ID, headers).subscribe(
			(response) => {
				const question = this.questions.find(items => items.ID === this.currentQuestion.ID);
				if (question) {
					question.answer = this.currentQuestion.answer;
					question.skipped = this.currentQuestion.skipped;
					question.markForReview = this.currentQuestion.markForReview;
				}
				if (this.questions[this.currentIndex + 1]) {
					this.updateNavigation('next');
					this.currentQuestion = { ...this.questions[this.currentIndex + 1] };
					this.currentIndex += 1;
					this.popupRef.componentInstance.popupLoader = false;
					this.loader = false;
					this.submitButtonDisable = false;
				} else {
					if (this.reachedEnd) {
						this.action = 'testEnd';
						this.calculateTotal();
						this.popupRef.componentInstance.popupLoader = false;
						this.loader = false;
						this.submitButtonDisable = false;
					} else {
						this.getQuestion(false, 'next');
						this.currentIndex += 1;
					}
				}
				// if (next) {
				// 	let action;
				// 	if (updateNavigationAction) {
				// 		action = 'next';
				// 	}
				// } else {
				// 	this.updateNavigation('next');
				// 	this.questions[this.currentIndex] = this.currentQuestion;
				// 	if (this.questions[this.currentIndex + 1]) {
				// 		this.currentQuestion = this.questions[this.currentIndex + 1];
				// 		this.currentIndex += 1;
				// 	}
				// 	this.popupRef.componentInstance.popupLoader = false;
				// 	this.loader = false;
				// 	this.submitButtonDisable = false;
				// }
			},
			(error) => {
				if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === 'ASSESSMENT_INTERRUPTED') {
					if (this.popupRef) {
						this.popupRef.close('close');
					}
					error.error = this.locale.translate('the_test_was_interrupted');
				}
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		)
			.add(() => {

			});

	}

	review() {
		if (navigator.onLine) {
			if (this.navigationData[this.currentNavigationIndex]) {
				this.navigationData[this.currentNavigationIndex].type = 'current';
			}
			this.action = 'testInprogress';
		}
	}

	endTest(action) {
		if (navigator.onLine) {
			this.popupRef.componentInstance.popupLoader = true;
			this.submitButtonDisable = true;
			const apiData: any = {};
			const headers: any = {};
			this.apiService.endTest(apiData, this.userTestID, headers).subscribe(
				(response) => {
					this.endTestData = response;
					if (action === 'timeUp') {
						this.action = 'timeUp';
						// this.calculateTotal();
					} else if (action === 'completed') {
						this.action = 'testCompleted';
					}
				},
				(error) => {
					if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === 'ASSESSMENT_INTERRUPTED') {
						error.error = this.locale.translate('the_test_was_interrupted');
					} else if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === 'ASSESSMENT_COMPLETED') {
						error.error = this.locale.translate('already_you_will_be_completed_the_test');
					}
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
				.add(() => {
					this.testData.testEnded = true;
					this.popupRef.componentInstance.popupLoader = false;
					this.submitButtonDisable = false;
					if (this.heartBeatInterval) {
						clearInterval(this.heartBeatInterval);
					}
					if (this.interval) {
						clearInterval(this.interval);
					}
				});
		}
	}

	calculateTotal() {
		this.totalAnswerCount = 0;
		for (const data of this.navigationData) {
			if (['answered', 'mark-review'].includes(data.type)) {
				this.totalAnswerCount += 1;
			}
		}
	}

	formatTime(timeInSeconds) {
		// Hours, minutes and seconds
		var hrs: any = ~~(timeInSeconds / 3600);
		var mins = ~~((timeInSeconds % 3600) / 60);
		var secs = ~~timeInSeconds % 60;
		hrs = hrs.toString().padStart(2, '0');
		// Output like "1:01" or "4:03:59" or "123:03:59"
		var ret = '';
		// if (hrs > 0) {
		ret += '' + hrs + ':' + (mins < 10 ? '0' : '');
		// }
		ret += '' + mins + ':' + (secs < 10 ? '0' : '');
		ret += '' + secs;
		return ret;
	}

	showQuestions() {
		if (navigator.onLine) {
			if (!this.lastAction) {
				this.lastAction = this.action;
			}
			let status = false;
			if (this.questions.length && this.questions.find(items => items.skipped || items.markForReview || items.answer)) {
				status = true;
			}
			if (status && navigator.onLine) {
				if (this.action === 'questions') {
					const action: any = this.lastAction;
					if (this.testData.testEnded) {
						this.action = 'testCompleted';
					} else {
						this.action = action;
						this.lastAction = null;
					}
				} else {
					this.action = 'questions';
				}
			}
		}
	}

	dialogClose() {
		if (this.action === 'testInprogress' || this.action === 'testEnd') {
			this.alertPopup(this.action, null);
		} else if (this.action === 'questions') {
			const action: any = this.lastAction;
			this.action = action;
			this.lastAction = null;
		} else {
			this.popupRef.close('close');
		}
	}

	alertPopup(action, data, additionalInfo: any = {}) {
		let title = '';
		let content = '';
		if (action === 'testInprogress' || action === 'testEnd') {
			title = this.locale.translate('quit');
			content = this.locale.translate('quit_test_text');
		}
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			autoFocus: false,
			data: {
				action: 'alert',
				classes: 'warning',
				popup: true,
				icon: 'warning',
				title,
				content,
				buttons: [
					{
						type: 'main-action',
						caption: this.locale.translate('yes'),
						key: 'yes'
					},
					{
						type: 'main-action',
						caption: this.locale.translate('no'),
						key: 'no',
						autoFocus: true
					}
				],
				triggerEl: additionalInfo.actionElement
			},
			disableClose: true,
			maxWidth: '560px'
		});
		dialogRef.afterClosed().subscribe((resp) => {
			if (resp) {
				if (resp.key === 'yes') {
					if (action === 'testInprogress' || action === 'testEnd') {
						this.popupRef.close('close');
					}
				}
			}
		});
	}

	closeTest() {
		if (this.popupRef) {
			this.popupRef.close('completed')
		}
	}

	ngOnDestroy() {
		if (this.interval) {
			clearInterval(this.interval);
		}
		if (this.heartBeatInterval) {
			clearInterval(this.heartBeatInterval);
		}
	}

}
